"use client";

import Image from "next/image";

const clients = [
    { name: "Stock Squad", logo: "/clients/stock-squad.webp", width: 120, height: 40 },
    { name: "Reklame", logo: "/clients/reklame.webp", width: 130, height: 50 },
    { name: "Senjoy", logo: "/clients/senjoy.webp", width: 150, height: 50 },
    { name: "SIX", logo: "/clients/six.webp", width: 100, height: 40 },
    { name: "DRC Suppliers", logo: "/clients/drc-suppliers.webp", width: 140, height: 45 },
    { name: "Amala Earth", logo: "/clients/amala-earth.webp", width: 140, height: 45 },
    { name: "Bijli", logo: "/clients/bijli.webp", width: 140, height: 45 },
    { name: "Botanical Remedies", logo: "/clients/botanical-remedies.webp", width: 140, height: 45 },
    { name: "Khaitan & Co.", logo: "/clients/khaitan.webp", width: 140, height: 45 },
    { name: "Mada Insurance", logo: "/clients/mada.webp", width: 140, height: 45 },
    { name: "Merrier Coffee", logo: "/clients/merrier-coffee.webp", width: 140, height: 45 },
    { name: "Tradegully", logo: "/clients/tradegully.webp", width: 140, height: 45 },
    { name: "Wherehouse", logo: "/clients/wherehouse.webp", width: 140, height: 45 },
    { name: "ZipGrid", logo: "/clients/zg.webp", width: 140, height: 45 },
];

export default function TrustedBy() {
    // Duplicate the clients array to create a seamless loop
    const displayClients = [...clients, ...clients, ...clients, ...clients];

    return (
        <section className="py-12 border-y border-zinc-200 bg-white overflow-hidden relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <p className="text-center text-sm font-mono uppercase tracking-widest mb-10 text-gray-500">
                    Trusted by forward-thinking companies
                </p>
            </div>

            {/* Marquee Container */}
            <div className="relative w-full overflow-hidden">
                {/* Gradient Masks for fade effect at edges */}
                <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
                <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

                <div
                    className="flex w-max items-center gap-12 md:gap-24 whitespace-nowrap animate-marquee"
                    style={{ willChange: "transform", animationDuration: "60s" }}
                >

                    {displayClients.map((client, i) => (
                        <div
                            key={`${client.name}-${i}`}
                            className="relative flex-none flex items-center justify-center"
                        >
                            <Image
                                src={client.logo}
                                alt={`${client.name} Logo`}
                                width={client.width}
                                height={client.height}
                                className="object-contain"
                                style={{ width: "auto", height: "2.5rem" }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
